export const NO_GUIDELINE = "no_guideline";
export const CONTACT_GUIDELINE = "contact_guideline";
export const DISABLED_ORGANIZATIONAL_GUIDELINES_APPS = ["idf"]; //temp hack to hide the organizational guidelines button for certain apps (lowercase)
